import React, { Component } from 'react';
import Modal from 'react-modal';
import Dropdown from '../form/base/DropDown';
import TextField from '../form/base/TextField';
import FullName from '../form/simple/FullName';
import FullPhone from '../form/simple/FullPhone';
import Email from '../form/simple/Email';
import { FormikConsumer } from 'formik';
import { AppContext } from '../../context/AppContext';

class InfoForm extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: this.props.open
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.context.hideInfo();
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  render() {
    return (
      <Modal
        isOpen={this.props.open}
        className="info-form-modal"
        contentLabel="Organization Information Form">
        <FormikConsumer>
          {({ dirty, errors }) => (
            <div>
              <button className="info-form-modal__close" onClick={this.closeModal}>
                <svg className="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlinkHref="/themes/custom/cdcnpin/img/uswds/sprite.svg#close"></use>
                </svg>
              </button>
              <h3>Before You Get Started</h3>
              <small>Selecting this organization will reload the form and enable you to make and submit edits to the
                current information on file. Before you get started, please enter the following information.
              </small>

              <div className="about-organization">
                <h4>About your Organization:</h4>
                <div className="wrapper-content">
                  <Dropdown label="Is this organization still operating?"
                    options={[{ label: 'Yes', value: 'yes' }, { label: 'No', value: 'no' }]}
                    name="info_status" />

                  <TextField label="Name of the Organization"
                    disabled={true}
                    name="organization_name_1" />
                </div>
              </div>
              <div className="about-you">
                <h4>About You:</h4>
                <div className="wrapper-content">
                  <FullName />
                  <TextField label="Job Title" name="info_job_title" />
                  <FullPhone />
                  <Email />
                </div>
              </div>
              <div className="disclaimer">
                <h4>About This Information</h4>
                <div className="wrapper-content">
                  <p>The contact information will not be accessible to anyone other than NPIN staff. NPIN staff will use
                    this information to periodically update your organization information.</p>
                </div>
              </div>
              <div className="submit">
                <button type="button"
                  className='usa-button'
                  onClick={this.handleSubmit}
                  disabled={(!dirty || (dirty && Object.keys(errors).filter((name) => name.startsWith('info_')).length))}>
                  Continue
                </button>
                <span>Before you get started, please enter the information above.</span>
              </div>
            </div>
          )}
        </FormikConsumer>
      </Modal>
    );
  }
}

export default InfoForm;
